import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { PrismHeaders } from '../enums';
import { map } from 'rxjs/operators';
import { SnackbarService } from './snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class ProcessorsService {
  constructor(
    private http: HttpClient,
    private snackbarService: SnackbarService
  ) {}

  private fetchingProcessors: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private fetchingProcessorCount: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private _processorsListPaginationData: BehaviorSubject<any> = new BehaviorSubject<any>({
    pageSize: 10,
    pageIndex: 0
  });

  getProcessors(isActive = true) {
    const paginationData = this._processorsListPaginationData.value;
    const headers = new HttpHeaders().append(
      PrismHeaders.QueryData,
      JSON.stringify({ ...paginationData, disabled: !isActive })
    );

    this.http
      .get(environment.apiBaseUrl + '/admin-get-processors', { headers })
      .pipe(
        take(1),
        map((response: any) => {
          return response.data.map((data: any) => {
            return {
              id: data.id,
              firstName: (data.firstName = data.firstName === undefined ? '-' : data.firstName),
              lastName: (data.lastName = data.lastName === undefined ? '-' : data.lastName),
              loginEmail: data.loginEmail,
              disabled: data.disabled
            };
          });
        })
      )
      .subscribe(
        (data) => {
          this.fetchingProcessors.next(data);
        },
        (err) => {
          console.error(err);
          this.snackbarService.handleError('Could not load processors.');
          this.fetchingProcessors.next([]);
        }
      );
  }

  getProcessorCountData(isActive = true) {
    const headers = new HttpHeaders().append(
      PrismHeaders.QueryData,
      JSON.stringify({ disabled: !isActive })
    );
    this.http
      .get(environment.apiBaseUrl + '/admin-get-processor-count', { headers })
      .pipe(
        take(1),
        map((countResponse: any) => {
          return countResponse.data;
        })
      )
      .subscribe(
        (data) => {
          this.fetchingProcessorCount.next(data);
        },
        (err) => {
          console.error(err);
          this.fetchingProcessorCount.next(0);
        }
      );
  }

  createProcessor(processorData: any) {
    return this.http
      .post(environment.apiBaseUrl + '/admin-create-processor', { profile: processorData })
      .pipe(take(1));
  }

  getProcessor(data: any) {
    let email = data.loginEmail;
    let headers = new HttpHeaders().append(PrismHeaders.QueryData, JSON.stringify({ email }));
    return this.http.get(environment.apiBaseUrl + '/admin-get-processor', { headers });
  }

  setProcessorStatus({ loginEmail, disabled }: { loginEmail: string; disabled: boolean }) {
    return this.http.put(environment.apiBaseUrl + '/admin-put-processor-status', {
      email: loginEmail,
      disabled
    });
  }

  updateProcessorPermissions(body: any) {
    return this.http.put(environment.apiBaseUrl + '/admin-put-processor-permissions', body);
  }

  getProcessorsListUpdateListener$() {
    return this.fetchingProcessors.asObservable();
  }

  getProcessorsCountListener$() {
    return this.fetchingProcessorCount.asObservable();
  }

  updateJobsListPagination({ pageSize, pageIndex }: any) {
    this._processorsListPaginationData.next({ pageSize, pageIndex });
  }
}
